<template>
  <div>
    <div class="pb-3 pt-3">
      <h5>
        <strong @click="$emit('toIndex')" style="cursor: pointer">
          <arrow-left-icon class="pb-1"/>
          Voltar para a listagem de credenciais
        </strong>
      </h5>
    </div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Credencial</strong></h5>
      </div>
        
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-6">
            <div>
              <p><strong>Apelido: </strong>{{ credential.nickname }}</p>
            </div>
            <div>
              <p><strong>Preferencial: </strong>{{ credential.preferential ? 'Sim' : 'Não' }}</p>
            </div>
            <div>
              <p><strong>Serviço: </strong>{{ credential.serviceName }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <p><strong>Criado por: </strong>{{ credential.createdBy }}</p>
            </div>
            <div>
              <p><strong>Criado em: </strong>{{ credential.createdAt | datetime }}</p>
            </div>

            <template v-if="credential.updatedBy">
              <div>
                <p><strong>Atualizado por: </strong>{{ credential.updatedBy }}</p>
              </div>
              <div>
                <p><strong>Atualizado em: </strong>{{ credential.updatedAt | datetime }}</p>
              </div>
            </template>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <button
              v-if="$withPolicy('application', 'credentials/insert_or_update')"
              class="btn btn-outline btn-md mr-2"
              @click="$emit('editCredential', credential)"
            >
              Editar
            </button>

            <button
              v-if="$withPolicy('application', 'credentials/delete')"
              class="btn btn-outline-red float-right"
              @click="$emit('sendDeleteCredential', credential)"
            >
              Excluir credencial
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ArrowLeftIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon },
    name: 'Show',
    props: {
      credential: { required: true, type: Object }
    }
  }
</script>

<style scoped lang="scss">
 .card{
    height: 100%;
  }

  p{
    color: black;
  }

  .table td{
    vertical-align: middle;
  }

</style>
